import {BrowserInfos} from "./UserSession.model";
import {H} from "../helpers/H";

export class ActivityTrace {
    id: string;
    uid: string;
    activity_type: string;
    activity_arg1: string;
    activity_arg2: any;
    app_ver: string;
    app_ver_ts: number;
    deviceInfos: BrowserInfos;
    site_uid: string;
    site_ref: string;
    user_name: string;
    user_email: string;
    user_group: string;
    ts: any;
    date: Date;

    constructor(dynProps: any = {}) {
        Object.keys(dynProps).forEach(key => {
            this[key] = dynProps[key];
        });

        if (!this.uid && this.user_email && this.activity_type) {
            this.uid = this.user_email + "_" + H.getDateHourCompact() + "V3_" + this.activity_type + "_" + H.randomStr(6);
        }

        if (this.ts) {
            this.date = this.tsToDate(this.ts);
        }
    }

    toJson(): any {
        return this.cleanJson({
            id: this.id,
            uid: this.uid,
            activity_type: this.activity_type,
            activity_arg1: this.activity_arg1,
            activity_arg2: this.activity_arg2,
            app_ver: this.app_ver,
            app_ver_ts: this.app_ver_ts,
            deviceInfos: this.deviceInfos ? {...this.deviceInfos} : null,
            site_uid: this.site_uid,
            site_ref: this.site_ref,
            user_name: this.user_name,
            user_email: this.user_email,
            user_group: this.user_group,
            ts: this.ts,
        });
    }

    private tsToDate(ts: any): Date {
        if (!ts) return null;
        if (ts instanceof Date) return ts;
        if (typeof ts?.toDate === "function") return ts.toDate();
        if (typeof ts?.seconds === "number") {
            return new Date(ts.seconds * 1000 + (ts.nanoseconds || 0) / 1000000);
        }
        if (typeof ts === "number" || typeof ts === "string") return new Date(ts);
        return null;
    }

    private cleanJson(value: any): any {
        if (Array.isArray(value)) {
            return value.map(item => this.cleanJson(item));
        }

        if (value && typeof value === "object") {
            const cleanedObj = H.cleanUndefined(value);
            const result = {};

            Object.keys(cleanedObj).forEach(key => {
                result[key] = this.cleanJson(cleanedObj[key]);
            });

            return result;
        }

        return value;
    }
}
